import {createBlockedShift, deleteBlockedShift, getHereToken, getPublicSupplierData, getSupplierData} from "../api";
import {GET_SUPPLIER, UPDATE_BLOCKED_TIME, UPDATE_HERE_TOKEN} from "./action";

export const getSupplierDataAction = (dispatch) => (authToken) => {
    dispatch({type: GET_SUPPLIER, payload: null})
    getSupplierData(authToken).then(({data}) => {
        dispatch({type: GET_SUPPLIER, payload: data})
    })
}
export const getPublicSupplierDataAction  = (dispatch) => (shortHash) => {
    getPublicSupplierData(shortHash).then(({data}) => {
        dispatch({type: GET_SUPPLIER, payload: data})
    })
}
export const createBlockedTimeAction = (dispatch) => (payload) => {
    createBlockedShift(payload).then(({data}) => {
        dispatch({type: UPDATE_BLOCKED_TIME, payload: data})
    })
}
export const deleteBlockedTimeAction = (dispatch) => (payload) => {
    deleteBlockedShift(payload).then(({data}) => {
        dispatch({type: UPDATE_BLOCKED_TIME, payload: data})
    })
}
export const updateHereToken = (dispatch) => () => {
    getHereToken().then(({data}) => {
        dispatch({type: UPDATE_HERE_TOKEN, payload: data})
    })
}